import { erzeugeAufnahmeEingabe, istCheckoutDart, letzterDart } from "./aufnahme-eingabe.js";
import { t, tf } from "./i18n.js";
// ==========================================
// PARTY X01 LOGIK (Couch-Koop)
// ==========================================

let partyPlayers = [];
// Double-Out (15.08.2026): Vorgabe AUS. Party ist der Gelegenheitsmodus -
// wer die Turnierregel will, schaltet sie im Setup an. Erst pruefbar, seit
// die Aufnahme aus einzelnen Darts besteht.
let partyDoubleOut = false;
let partyStartingScore = 501;
let currentPartyTurnIndex = 0;
let partyHistoryStack = []; // <-- NEU: Speichert den Spielverlauf

// --- 1. SETUP LOGIK ---

function addPartyPlayer() {
  const input = document.getElementById("party-player-input");
  const name = input.value.trim();

  if (name === "") return;
  if (partyPlayers.length >= 8) {
    showToast(t("js.gotcha.001"), "warning");
    return;
  }
  if (partyPlayers.some((p) => p.name.toLowerCase() === name.toLowerCase())) {
    showToast(t("js.gotcha.002"), "warning");
    return;
  }

  partyPlayers.push({
    name: name,
    score: partyStartingScore,
    dartsThrown: 0,
  });

  input.value = "";
  updatePartyPlayerList();
}

function removePartyPlayer(index) {
  partyPlayers.splice(index, 1);
  updatePartyPlayerList();
}

function updatePartyPlayerList() {
  const list = document.getElementById("party-player-list");
  list.innerHTML = "";

  partyPlayers.forEach((p, index) => {
    const li = document.createElement("li");
    li.style.cssText =
      "display: flex; justify-content: space-between; align-items: center; background: #222; padding: 10px 15px; margin-bottom: 5px; border-radius: 6px;";

    // FIX: Name per textContent statt innerHTML. Vorher konnte ein Name wie
    // "<img src=x onerror=...>" ausgefuehrt werden bzw. das Layout zerlegen.
    const nameSpan = document.createElement("span");
    nameSpan.style.cssText = "font-weight: bold; font-size: 1.1em;";
    nameSpan.textContent = `${index + 1}. ${p.name}`;

    const delBtn = document.createElement("button");
    delBtn.textContent = "X";
    delBtn.style.cssText =
      "background: var(--accent-red); color: white; border: none; border-radius: 4px; padding: 5px 12px; cursor: pointer; font-weight: bold;";
    delBtn.onclick = () => removePartyPlayer(index);

    li.appendChild(nameSpan);
    li.appendChild(delBtn);
    list.appendChild(li);
  });
}

function startPartyGame() {
  if (partyPlayers.length < 1) {
    showToast(t("js.party.001"), "warning");
    return;
  }

  partyStartingScore = parseInt(
    document.getElementById("party-starting-score").value
  );
  partyDoubleOut = !!document.getElementById("chk-party-double-out")?.checked;

  partyPlayers.forEach((p) => {
    p.score = partyStartingScore;
    p.dartsThrown = 0;
  });

  currentPartyTurnIndex = 0;
  partyHistoryStack = []; // <-- NEU: Historie beim Start leeren

  // Undo-Button beim Start verstecken
  let undoBtn = document.getElementById("btn-undo-party");
  if (undoBtn) undoBtn.style.display = "none";

  updatePartyScoreboard();
  updatePartyTurnIndicator();

  document.getElementById("party-setup-screen").style.display = "none";
  document.getElementById("game-party-screen").style.display = "block";

  // ERST nach dem Sichtbarmachen: Der Baustein misst beim Aufbau das Board,
  // und ein Element in einem display:none-Zweig hat die Groesse 0.
  bereitePartyEingabe();

  // Spielwache scharf (29.08.2026): Warnung vor Reload + Spiegel fuer
  // die Fortsetzen-Kachel.
  spielwacheSpielGestartet("party", sicherePartyStand);
}

// ── Spielwache: sichern & wiederherstellen (29.08.2026) ─────────────────
// Der Stand ist klein und vollstaendig: Spieler, Regeln, wer dran ist.
// Eine HALBE Aufnahme (Darts in den Slots) wird bewusst nicht gespiegelt -
// nach einem Reload beginnt die Aufnahme des aktiven Spielers neu, wie
// nach einem Undo.
function sicherePartyStand() {
  return {
    players: partyPlayers,
    startScore: partyStartingScore,
    doubleOut: partyDoubleOut,
    turnIndex: currentPartyTurnIndex,
  };
}

function stellePartyWieder(stand) {
  openPartySetup(); // Navigation + App-Modus wie auf dem normalen Weg
  partyPlayers = stand.players.map((p) => ({ ...p }));
  partyStartingScore = stand.startScore;
  partyDoubleOut = !!stand.doubleOut;
  currentPartyTurnIndex = stand.turnIndex;
  partyHistoryStack = [];

  // Setup-Formular angleichen, damit Revanche/Setup danach stimmen.
  const startFeld = document.getElementById("party-starting-score");
  if (startFeld) startFeld.value = partyStartingScore;
  const doppelHaken = document.getElementById("chk-party-double-out");
  if (doppelHaken) doppelHaken.checked = partyDoubleOut;

  const undoBtn = document.getElementById("btn-undo-party");
  if (undoBtn) undoBtn.style.display = "none";

  updatePartyScoreboard();
  updatePartyTurnIndicator();
  document.getElementById("party-setup-screen").style.display = "none";
  document.getElementById("game-party-screen").style.display = "block";
  bereitePartyEingabe();
  spielwacheSpielGestartet("party", sicherePartyStand);
}

spielwacheRegistriereFortsetzen("party", "Party X01", stellePartyWieder);

function cancelPartyGame() {
  cancelCurrentGame("game-party-screen");
}

// --- NEU: UNDO LOGIK ---

function savePartyState() {
  // Erstellt eine tiefe Kopie (Snapshot) des aktuellen Status
  partyHistoryStack.push({
    players: JSON.parse(JSON.stringify(partyPlayers)),
    turnIndex: currentPartyTurnIndex,
  });

  // Zeigt den Undo-Button an
  document.getElementById("btn-undo-party").style.display = "block";
}

function undoPartyTurn() {
  if (partyHistoryStack.length === 0) return;

  // Holt den letzten Snapshot zurück
  const lastState = partyHistoryStack.pop();
  partyPlayers = lastState.players;
  currentPartyTurnIndex = lastState.turnIndex;

  // Halbfertige Aufnahme verwerfen: Nach einem Undo gehoert der Rueckstand
  // des vorigen Spielers nicht in die Slots des jetzigen.
  partyEingabe.leere();

  // UI aktualisieren
  updatePartyScoreboard();
  updatePartyTurnIndicator();

  // Button verstecken, falls wir ganz am Anfang sind
  if (partyHistoryStack.length === 0) {
    document.getElementById("btn-undo-party").style.display = "none";
  }
}

// --- 2. SPIEL LOGIK & SCOREBOARD ---

function updatePartyTurnIndicator() {
  const currentPlayer = partyPlayers[currentPartyTurnIndex];
  if (!currentPlayer) return;

  // Checkout-Weg anzeigen (Nutzt die Funktion aus game-501.js)
  const checkoutPath =
    typeof getCheckoutPath === "function"
      ? getCheckoutPath(currentPlayer.score)
      : "";
  const checkoutDiv = document.getElementById("party-checkout-display");

  if (checkoutPath) {
    checkoutDiv.innerText = tf("js.g121.007", { p1: checkoutPath });
    checkoutDiv.style.opacity = "1";
  } else {
    checkoutDiv.innerText = "";
    checkoutDiv.style.opacity = "0";
  }

}

function updatePartyScoreboard() {
  // Bei 2 Spielern links/rechts, ab 3 Spielern Vorheriger-Aktiv-Naechster.
  renderPlayerCarousel(
    "party-scoreboard",
    partyPlayers.map((p) => ({
      name: p.name,
      score: p.score,
      sub: p.dartsThrown > 0 ? tf("js.friends.011", { p1: p.dartsThrown }) : "",
    })),
    currentPartyTurnIndex,
    { accent: "var(--accent-blue)" },
  );
  // Nach jeder Standaenderung spiegeln (spielwache.js, 29.08.2026).
  if (typeof spielwacheTick === "function") spielwacheTick();
}

// --- 3. WERTUNG ---
//
// appendPartyInput/deletePartyInput sind mit dem Ziffernblock entfallen
// (14.08.2026): Eine Aufnahme kommt jetzt als drei Darts aus dem Baustein
// aufnahme-eingabe.js, nicht als getippte Summe.

/** Eine Aufnahme werten.
 *
 * `wuerfe` ist die Dartliste des Bausteins; sie ist optional, damit ein
 * Bot oder ein Test weiterhin nur die Summe uebergeben kann. Aus ihr kommt
 * die ECHTE Dartzahl - vorher wurden pauschal 3 gezaehlt, auch wenn das Leg
 * mit dem ersten Dart endete (offener Punkt D4 der TODO-Liste).
 *
 * Rueckgabe: false, wenn die Aufnahme abgelehnt wurde - der Baustein laesst
 * die Darts dann stehen, statt sie kommentarlos zu verwerfen. */
function submitPartyScore(presetScore = null, wuerfe = null) {
  const score = Number(presetScore);
  if (!Number.isFinite(score)) return false;

  if (score > 180) {
    showToast(t("js.gotcha.004"), "warning");
    return false;
  }

  // <-- NEU: Snapshot speichern, BEVOR wir etwas verändern!
  savePartyState();

  let player = partyPlayers[currentPartyTurnIndex];
  let newScore = player.score - score;

  // Double-Out, wenn im Setup gewaehlt (15.08.2026): Die Null zaehlt nur,
  // wenn der LETZTE Dart ein Doppel oder das Bullseye war. Ohne Dartliste
  // (Bot, Test, alter Aufrufer) bleibt es beim milderen Verhalten - sonst
  // wuerde still haerter gewertet, als der Aufrufer wissen kann.
  const verfehltesFinish =
    partyDoubleOut &&
    newScore === 0 &&
    Array.isArray(wuerfe) &&
    wuerfe.length > 0 &&
    !istCheckoutDart(letzterDart(wuerfe));
  if (verfehltesFinish) newScore = -1; // faellt unten in den Bust-Zweig

  // Echte Dartzahl, wenn der Baustein sie mitliefert. Beim Bot oder
  // einem Test ohne Liste bleibt es bei der Aufnahme zu drei Pfeilen.
  player.dartsThrown += Array.isArray(wuerfe) && wuerfe.length ? wuerfe.length : 3;

  // FIX: Restscore 1 ist mit Double-Out nicht checkbar und zaehlt als Bust.
  // Vorher fehlte die Bedingung, 501 und 121 hatten sie bereits.
  //
  // Der Rest-1-Bust gilt UNABHAENGIG von der Option: Er folgt zwar aus der
  // Double-Out-Regel, steht aber seit jeher hier und ist die Bedingung, die
  // Party mit 501 und 121 teilt. Ihn an die Option zu haengen waere eine
  // stille Regelaenderung fuer alle, die sie nicht einschalten.
  if (newScore < 0 || newScore === 1) {
    showToast(
      verfehltesFinish
        ? tf("party.bustDoppel", { p1: player.name })
        : tf("js.party.003", { p1: player.name }),
      "error",
    );
  } else if (newScore === 0) {
    player.score = 0;
    updatePartyScoreboard();
    spielwacheSpielBeendet();

    // Gemeinsamer Endbildschirm statt Toast + goHome (Produkttest
    // 29.08.2026): Platzierung nach Restpunkten, Revanche behaelt die
    // eingetippten Namen - der groesste Gewinn bei Party-Abenden.
    setTimeout(() => {
      zeigeEndbildschirm({
        screenId: "game-party-screen",
        titel: tf("js.ende.sieg", { p1: player.name }),
        untertitel: tf("js.party.004", { p1: player.name }),
        zeilen: [...partyPlayers]
          .sort((a, b) => a.score - b.score)
          .map((p) => ({ name: p.name, wert: p.score, aktiv: p === player })),
        kennzahlen: [],
        revanche: () => startPartyGame(),
        setup: () => openPartySetup(),
      });
    }, 300);
    return true;
  } else {
    player.score = newScore;
  }

  currentPartyTurnIndex++;
  if (currentPartyTurnIndex >= partyPlayers.length) {
    currentPartyTurnIndex = 0;
  }

  updatePartyScoreboard();
  updatePartyTurnIndicator();
  return true;
}

// ---------------------------------------------------------------------------
// EINGABE (14.08.2026): ein Baustein statt Ziffernblock + eigenem Rechner
//
// Der Baustein sammelt drei Darts - von Hand ueber Board oder Tastatur, oder
// vom Tracker. Party braucht daraus nur die Summe; die Dartliste geht
// trotzdem mit, damit dartsThrown stimmt und die Einzelfelder nicht auf dem
// Weg verloren gehen.
//
// Die Registrierung beim Auto-Scoring macht der Baustein selbst.
// ---------------------------------------------------------------------------
const partyEingabe = erzeugeAufnahmeEingabe({
  modus: "party",
  ziel: () => document.getElementById("aufnahme-party"),
  aktiv: () =>
    document.getElementById("game-party-screen")?.style.display !== "none" &&
    partyPlayers.length > 0,
  onAufnahme: (wuerfe, summe) => submitPartyScore(summe, wuerfe),
});

// Beim Spielstart aufbauen und leeren - der Container existiert erst, wenn
// der Bildschirm sichtbar ist.
function bereitePartyEingabe() {
  partyEingabe.baue();
  partyEingabe.leere();
  partyEingabe.aktualisiereSichtbarkeit();
}

Object.assign(window, {
  addPartyPlayer,
  startPartyGame,
  cancelPartyGame,
  submitPartyScore,
  bereitePartyEingabe,
  partyEingabe,
});
